// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-desc[data-v-022ec96e] {\n  color: #939494;\n}", ""]);
// Exports
module.exports = exports;
